import React, { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
// LOCAL IMPORT
import Dashboard from '../Pages/Dashboard'
import Locations from '../Pages/Locations'
import PageNotFound from '../Pages/404'
// Pages
const Companies = React.lazy(() => import('../Pages/Companies'))
const Users = React.lazy(() => import('../Pages/Users'))
const Sites = React.lazy(() => import('../Pages/Sites'))
const SiteConfigs = React.lazy(() => import('../Pages/SiteConfigs'))
const Settings = React.lazy(() => import('../Pages/Settings'))
const LocationsRemax = React.lazy(() => import('../Pages/LocationsRemax'))
const PropertyMap = React.lazy(() => import('../Pages/PropertyMap'))
const Properties = React.lazy(() => import('../Pages/Properties'))
const TrexoReports = React.lazy(() => import('../Pages/TrexoReports'))
const Reports = React.lazy(() => import('../Pages/Reports'))
const Brik = React.lazy(() => import('../Pages/Brik'))

export default function Content(props) {
	return (
		<Suspense fallback={<div>Cargando...</div>}>
			<div className={`${props.showBars && 'content'}`} id="alterestate-container">
				<Routes>
					<Route index element={<Dashboard />} />
					<Route path="companies/*" element={<Companies />} />
					<Route path="users/*" element={<Users />} />
					<Route path="sites/*" element={<Sites />} />
					<Route path="site-configs/*" element={<SiteConfigs />} />
					<Route path="site-configs/*" element={<SiteConfigs />} />
					<Route path="settings/*" element={<Settings />} />
					<Route path="locations/" element={<Locations />} />
					<Route path="locations-remax/" element={<LocationsRemax />} />
					<Route path="property-map/" element={<PropertyMap />} />
					<Route path="properties/*" element={<Properties />} />
					<Route path="trexo-reports/*" element={<TrexoReports />} />
					<Route path="reports/*" element={<Reports />} />
					<Route path="brik/*" element={<Brik />} />
					<Route path="*" element={<PageNotFound />} />
				</Routes>
			</div>
		</Suspense>
	)
}
